// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function toString(value) {
  switch (value) {
    case "Invoice" :
      return "invoice";
    case "SalesReceipt" :
      return "sales-receipt";
    case "CreditNote" :
      return "credit-note";
    case "RefundReceipt" :
      return "refund-receipt";
    case "DeliveryNote" :
      return "delivery-note";
    case "Quote" :
      return "quote";
  }
}

let UnknownStringValue = /* @__PURE__ */Primitive_exceptions.create("Sale.UnknownStringValue");

function fromStringExn(value) {
  switch (value) {
    case "credit-note" :
      return "CreditNote";
    case "delivery-note" :
      return "DeliveryNote";
    case "invoice" :
      return "Invoice";
    case "quote" :
      return "Quote";
    case "refund-receipt" :
      return "RefundReceipt";
    case "sales-receipt" :
      return "SalesReceipt";
    default:
      throw {
        RE_EXN_ID: UnknownStringValue,
        Error: new Error()
      };
  }
}

function toLabel(pluralOpt, value) {
  let plural = pluralOpt !== undefined ? pluralOpt : false;
  let tmp;
  switch (value) {
    case "Invoice" :
      tmp = "Invoice";
      break;
    case "SalesReceipt" :
      tmp = "Receipt";
      break;
    case "CreditNote" :
      tmp = "Credit note";
      break;
    case "RefundReceipt" :
      tmp = "Refund receipt";
      break;
    case "DeliveryNote" :
      tmp = "Delivery note";
      break;
    case "Quote" :
      tmp = "Quote";
      break;
  }
  return I18n.t(tmp + (
    plural ? "s" : ""
  ));
}

function toRevenueImpactTotalAmounts(saleType, totalAmountIncludingTaxes, totalAmountExcludingTaxes) {
  switch (saleType) {
    case "CreditNote" :
    case "RefundReceipt" :
      break;
    default:
      return [
        totalAmountIncludingTaxes,
        totalAmountExcludingTaxes
      ];
  }
  let total = totalAmountIncludingTaxes * -1;
  let total$1 = totalAmountExcludingTaxes * -1;
  return [
    total === -0 ? 0 : total,
    total$1 === -0 ? 0 : total$1
  ];
}

function toString$1(value) {
  switch (value) {
    case "Draft" :
      return "draft";
    case "Started" :
      return "started";
    case "Overdue" :
      return "overdue";
    case "Completed" :
      return "completed";
    case "Canceled" :
      return "canceled";
  }
}

function fromString(value) {
  switch (value) {
    case "canceled" :
      return {
        TAG: "Ok",
        _0: "Canceled"
      };
    case "completed" :
      return {
        TAG: "Ok",
        _0: "Completed"
      };
    case "draft" :
      return {
        TAG: "Ok",
        _0: "Draft"
      };
    case "overdue" :
      return {
        TAG: "Ok",
        _0: "Overdue"
      };
    case "started" :
      return {
        TAG: "Ok",
        _0: "Started"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}

function toLabel$1(partiallyPaidOpt, saleType, value) {
  let partiallyPaid = partiallyPaidOpt !== undefined ? partiallyPaidOpt : false;
  switch (value) {
    case "Draft" :
      return I18n.t("Draft");
    case "Started" :
      if (saleType === "Quote") {
        return I18n.t("To be approved");
      } else if (saleType === "Invoice" && partiallyPaid) {
        return I18n.t("To settle");
      } else if (saleType === "Invoice") {
        return I18n.t("To collect");
      } else {
        return "";
      }
    case "Overdue" :
      return I18n.t("Overdue");
    case "Completed" :
      if (saleType === "Invoice" || saleType === "SalesReceipt") {
        return I18n.t("Paid");
      } else if (saleType === "DeliveryNote") {
        return I18n.t("Sent");
      } else if (saleType === "Quote") {
        return I18n.t("Accepted");
      } else {
        return "";
      }
    case "Canceled" :
      if (saleType === "Invoice") {
        return I18n.t("Settled by credit note");
      } else if (saleType === "RefundReceipt") {
        return I18n.t("Refunded");
      } else if (saleType === "SalesReceipt") {
        return I18n.t("Canceled");
      } else {
        return "";
      }
  }
}

function fromRaw(dueDate, hasCreditNoteOpt, hasInvoiceOpt, value) {
  let hasCreditNote = hasCreditNoteOpt !== undefined ? hasCreditNoteOpt : false;
  let hasInvoice = hasInvoiceOpt !== undefined ? hasInvoiceOpt : false;
  let overdue;
  if (dueDate !== undefined) {
    let now = new Date();
    let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    overdue = today.getTime() > dueDate.getTime();
  } else {
    overdue = false;
  }
  if (value === "PAID" || value === "UNPAID") {
    if (hasCreditNote) {
      return "Canceled";
    } else if (value === "PAID") {
      if (hasInvoice) {
        return "Canceled";
      } else {
        return "Completed";
      }
    } else if (overdue) {
      return "Overdue";
    } else {
      return "Started";
    }
  } else {
    return "Draft";
  }
}

function toStyleSet(value, saleType) {
  switch (value) {
    case "Draft" :
      return {
        bgColor: "#E7E7EE",
        textColor: "#25243A",
        borderColor: "#A2A1B0",
        iconSvg: JsxRuntime.jsx(Icon.make, {
          name: "pending",
          fill: "#25243A",
          width: 10,
          height: 10,
          bold: true
        })
      };
    case "Started" :
      return {
        bgColor: "#FFF5C6",
        textColor: "#7A360D",
        borderColor: "#FFD84A",
        iconSvg: JsxRuntime.jsx(Icon.make, {
          name: "hourglass",
          fill: "#7A360D",
          width: 11,
          height: 11,
          bold: true
        })
      };
    case "Overdue" :
      return {
        bgColor: "#FFE5CF",
        textColor: "#7C2112",
        borderColor: "#FDAB74",
        iconSvg: JsxRuntime.jsx(Icon.make, {
          name: "status_warning",
          fill: "#7C2112",
          width: 12,
          height: 12,
          bold: true
        })
      };
    case "Completed" :
      return {
        bgColor: "#A2F8C8",
        textColor: "#00653E",
        borderColor: "#2ADD8B",
        iconSvg: JsxRuntime.jsx(Icon.make, {
          name: "status_ok",
          fill: "#00653E",
          width: 12,
          height: 12,
          bold: true
        })
      };
    case "Canceled" :
      if (saleType === "Invoice") {
        return {
          bgColor: "#E7E7EE",
          textColor: "#25243A",
          borderColor: "#A2A1B0",
          iconSvg: JsxRuntime.jsx("svg", {
            children: JsxRuntime.jsx("path", {
              d: "M8.53853 2.22213C8.53853 2.07729 8.49425 1.9352 8.4106 1.8149C8.32686 1.69449 8.20715 1.60125 8.06734 1.5483C7.92756 1.49541 7.77459 1.4857 7.62886 1.52047C7.48306 1.55529 7.35188 1.63302 7.25288 1.74215L7.24849 1.74703C7.18977 1.81002 7.11854 1.85995 7.03999 1.894C6.96145 1.92803 6.87684 1.94576 6.79146 1.94576C6.70607 1.94576 6.62147 1.92804 6.54292 1.894C6.46438 1.85995 6.39316 1.81005 6.33443 1.74703L6.33003 1.74215C6.23104 1.63302 6.09986 1.55529 5.95406 1.52047C5.80832 1.48571 5.65535 1.49539 5.51558 1.5483C5.37584 1.60122 5.25654 1.69459 5.17281 1.8149C5.08916 1.9352 5.04439 2.07729 5.04439 2.22213C5.04448 2.53986 5.27078 2.87821 5.56538 3.17086L6.79097 4.2983L8.01705 3.17135C8.14565 3.0434 8.28246 2.87615 8.38423 2.69723C8.48949 2.51217 8.53848 2.34851 8.53853 2.22213ZM8.61177 4.14156C8.50404 4.13855 8.4004 4.17827 8.32369 4.24996C8.31645 4.25672 8.30826 4.26227 8.30074 4.26852L7.13326 5.34225C7.12878 5.34645 7.12417 5.35044 7.11958 5.35445L6.43306 5.9858C6.41827 5.99939 6.40257 6.01143 6.38667 6.02291C6.12878 6.25743 5.793 6.38912 5.44331 6.38912H4.54439C4.26836 6.38905 4.04448 6.16515 4.04439 5.88912C4.04439 5.61302 4.2683 5.38919 4.54439 5.38912H5.44331C5.55086 5.38912 5.65313 5.34646 5.72749 5.27291C5.80154 5.19957 5.84224 5.10119 5.84224 4.99996C5.8422 4.89872 5.8016 4.80033 5.72749 4.72701C5.65313 4.65346 5.55086 4.61129 5.44331 4.61129H4.09517C3.92927 4.61129 3.87665 4.66374 3.86421 4.68014C3.84809 4.70138 3.83029 4.7213 3.81099 4.73971L1.66646 6.78414L2.769 7.87447L3.10884 7.58053C3.36604 7.27966 3.7411 7.16646 4.09517 7.16646H5.89253C6.26516 7.16646 6.5701 7.03517 6.77632 6.80221L6.80757 6.76998L8.87447 4.81441L8.87691 4.81246C8.95337 4.74096 8.99705 4.64343 8.99996 4.54195C9.00282 4.44049 8.96462 4.34102 8.89253 4.26559C8.82024 4.18997 8.71946 4.14458 8.61177 4.14156ZM9.53853 2.22262C9.53848 2.58491 9.40683 2.92152 9.25337 3.19137C9.23675 3.22059 9.21914 3.24936 9.20162 3.27779C9.35509 3.35037 9.49616 3.4496 9.61568 3.57467C9.87133 3.8422 10.01 4.20053 9.99947 4.57076C9.98889 4.93988 9.83035 5.28805 9.56148 5.54049L9.56197 5.54098L7.50337 7.48775C7.08194 7.94942 6.49817 8.16646 5.89253 8.16646H4.09517C3.92936 8.16646 3.87669 8.21889 3.86421 8.23531C3.84318 8.26304 3.81924 8.28871 3.79292 8.31148L3.48238 8.57955L3.54781 8.64449C3.74415 8.83867 3.74589 9.15518 3.55171 9.35152C3.35753 9.54782 3.04101 9.54959 2.84468 9.35543L0.148393 6.68893C-0.047943 6.49476 -0.0496632 6.17824 0.144487 5.98189C0.338661 5.78555 0.655174 5.78381 0.851518 5.97799L0.955522 6.08102L3.09908 4.03658C3.35648 3.72706 3.73661 3.61129 4.09517 3.61129H4.61372C4.33132 3.27113 4.04446 2.79233 4.04439 2.22262C4.04431 1.87274 4.15171 1.53144 4.35152 1.2441C4.55124 0.956899 4.83378 0.737247 5.16109 0.613242C5.48842 0.489278 5.84601 0.466523 6.18648 0.547813C6.40514 0.600028 6.61019 0.694249 6.79146 0.823203C6.97273 0.694234 7.17777 0.600031 7.39644 0.547813C7.73693 0.466507 8.09449 0.489271 8.42183 0.613242C8.74916 0.73724 9.03167 0.956898 9.2314 1.2441C9.43121 1.53144 9.53861 1.87274 9.53853 2.22262Z",
              fill: "#25243A"
            }),
            height: "11",
            width: "11",
            viewBox: "0 0 10 10"
          })
        };
      } else if (saleType === "RefundReceipt") {
        return {
          bgColor: "#FAD0E3",
          textColor: "#821938",
          borderColor: "#F8A9CC",
          iconSvg: JsxRuntime.jsx("svg", {
            children: JsxRuntime.jsx("path", {
              d: "M7.2251 8.5V7.10693L6.80859 7.53613C6.61617 7.73406 6.29958 7.73826 6.10156 7.5459C5.90363 7.35347 5.89894 7.03689 6.09131 6.83887L7.36621 5.52637C7.46036 5.42948 7.59 5.375 7.7251 5.375C7.86009 5.37503 7.98938 5.42959 8.0835 5.52637L9.3584 6.83887C9.55073 7.03686 9.54646 7.35346 9.34863 7.5459C9.15064 7.73823 8.83404 7.73396 8.6416 7.53613L8.2251 7.10742V8.5C8.2251 8.77611 8.00119 8.99995 7.7251 9C7.44896 9 7.2251 8.77614 7.2251 8.5ZM5.1001 4.125C5.1001 3.90413 4.92974 3.75 4.75 3.75C4.57026 3.75 4.3999 3.90413 4.3999 4.125C4.3999 4.34587 4.57026 4.5 4.75 4.5C4.92974 4.5 5.1001 4.34587 5.1001 4.125ZM8.5 4.5625V2.375C8.5 2.27094 8.45989 2.17378 8.39258 2.10449C8.32575 2.0357 8.23797 2 8.1499 2H1.3501C1.26203 2 1.17425 2.0357 1.10742 2.10449C1.04011 2.17378 1 2.27094 1 2.375V5.875C1 5.97906 1.04011 6.07622 1.10742 6.14551C1.17425 6.2143 1.26203 6.25 1.3501 6.25H4.75C5.02614 6.25 5.25 6.47386 5.25 6.75C5.25 7.02614 5.02614 7.25 4.75 7.25H1.3501C0.987301 7.25 0.64212 7.10168 0.390137 6.84229C0.138633 6.58338 0 6.23507 0 5.875V2.375C0 2.01493 0.138633 1.66662 0.390137 1.40771C0.64212 1.14832 0.987302 1 1.3501 1H8.1499C8.5127 1 8.85788 1.14832 9.10986 1.40771C9.36137 1.66662 9.5 2.01493 9.5 2.375V4.5625C9.5 4.83864 9.27614 5.0625 9 5.0625C8.72386 5.0625 8.5 4.83864 8.5 4.5625ZM2.2041 3.625C2.48024 3.625 2.7041 3.84886 2.7041 4.125C2.7041 4.40114 2.48024 4.625 2.2041 4.625H2.2002C1.92405 4.625 1.7002 4.40114 1.7002 4.125C1.7002 3.84886 1.92405 3.625 2.2002 3.625H2.2041ZM7.3042 3.625C7.58034 3.625 7.8042 3.84886 7.8042 4.125C7.8042 4.40114 7.58034 4.625 7.3042 4.625H7.2998C7.02375 4.62489 6.7998 4.40108 6.7998 4.125C6.7998 3.84892 7.02375 3.62511 7.2998 3.625H7.3042ZM6.1001 4.125C6.1001 4.87063 5.50915 5.5 4.75 5.5C3.99085 5.5 3.3999 4.87063 3.3999 4.125C3.3999 3.37937 3.99085 2.75 4.75 2.75C5.50915 2.75 6.1001 3.37937 6.1001 4.125Z",
              fill: "#821938"
            }),
            height: "12",
            width: "12",
            transform: "translate(1, 1)",
            viewBox: "0 0 10 10"
          })
        };
      } else {
        return {
          bgColor: "#E7E7EE",
          textColor: "#25243A",
          borderColor: "#BDBDCA",
          iconSvg: JsxRuntime.jsx(Icon.make, {
            name: "status_nok",
            fill: "#25243A",
            width: 12,
            height: 12,
            bold: true
          })
        };
      }
  }
}

let Badge = {
  toStyleSet: toStyleSet
};

let Status = {
  toString: toString$1,
  fromString: fromString,
  toLabel: toLabel$1,
  fromRaw: fromRaw,
  Badge: Badge
};

function toLabel$2(value) {
  switch (value) {
    case "Delivered" :
      return I18n.t("Delivered");
    case "Refunded" :
      return I18n.t("Refunded");
    case "Billed" :
      return I18n.t("Billed");
  }
}

function toStyleSet$1(value) {
  switch (value) {
    case "Delivered" :
      return {
        bgColor: "#E2EBF7",
        textColor: "#354473",
        borderColor: "#A9C5E7",
        iconSvg: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("path", {
            d: "M3 7.375C2.84159 7.375 2.7002 7.50757 2.7002 7.6875C2.7002 7.86743 2.84159 8 3 8C3.15841 8 3.2998 7.86743 3.2998 7.6875C3.2998 7.50757 3.15841 7.375 3 7.375ZM7 7.375C6.84159 7.375 6.7002 7.50757 6.7002 7.6875C6.7002 7.86743 6.84159 8 7 8C7.15841 8 7.2998 7.86743 7.2998 7.6875C7.2998 7.50757 7.15841 7.375 7 7.375ZM6.2998 6.58252C6.50124 6.452 6.7407 6.375 7 6.375C7.54688 6.375 8.00783 6.71344 8.20166 7.1875H8.5V5.83008L7.15723 4.125H6.2998V6.58252ZM5.2998 2.8125C5.2998 2.72718 5.26656 2.64689 5.20947 2.58887C5.15259 2.5311 5.07704 2.5 5 2.5H1.7998C1.72286 2.50005 1.64764 2.53119 1.59082 2.58887C1.53368 2.6469 1.5 2.72714 1.5 2.8125V7.1875H1.79834C1.99217 6.71344 2.45312 6.375 3 6.375C3.54688 6.375 4.00783 6.71344 4.20166 7.1875H5.2998V2.8125ZM6.2998 3.125H7.2085C7.31059 3.12515 7.41177 3.14276 7.50732 3.17676L7.60107 3.21631L7.68945 3.26611C7.77458 3.32049 7.85002 3.38879 7.9126 3.46826L9.3042 5.23486C9.43096 5.39533 9.4996 5.5938 9.5 5.79736V7.28125C9.5 7.51912 9.40716 7.7489 9.23926 7.91943C9.07111 8.0902 8.84128 8.18747 8.6001 8.1875H8.20166C8.00783 8.66156 7.54688 9 7 9C6.45312 9 5.99217 8.66156 5.79834 8.1875H4.20166C4.00783 8.66156 3.54688 9 3 9C2.45312 9 1.99217 8.66156 1.79834 8.1875H1.3999C1.15872 8.18747 0.928885 8.0902 0.760742 7.91943C0.592839 7.7489 0.5 7.51912 0.5 7.28125V2.8125C0.5 2.46691 0.635051 2.13392 0.87793 1.88721C1.12106 1.64027 1.45257 1.50005 1.7998 1.5H5C5.34729 1.5 5.6787 1.64025 5.92188 1.88721C6.1648 2.13392 6.2998 2.46688 6.2998 2.8125V3.125Z",
            fill: "#354473"
          }),
          height: "12",
          width: "12",
          viewBox: "0 0 9 10"
        })
      };
    case "Refunded" :
      return {
        bgColor: "#FAD0E3",
        textColor: "#821938",
        borderColor: "#F8A9CC",
        iconSvg: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("path", {
            d: "M7.2251 8.5V7.10693L6.80859 7.53613C6.61617 7.73406 6.29958 7.73826 6.10156 7.5459C5.90363 7.35347 5.89894 7.03689 6.09131 6.83887L7.36621 5.52637C7.46036 5.42948 7.59 5.375 7.7251 5.375C7.86009 5.37503 7.98938 5.42959 8.0835 5.52637L9.3584 6.83887C9.55073 7.03686 9.54646 7.35346 9.34863 7.5459C9.15064 7.73823 8.83404 7.73396 8.6416 7.53613L8.2251 7.10742V8.5C8.2251 8.77611 8.00119 8.99995 7.7251 9C7.44896 9 7.2251 8.77614 7.2251 8.5ZM5.1001 4.125C5.1001 3.90413 4.92974 3.75 4.75 3.75C4.57026 3.75 4.3999 3.90413 4.3999 4.125C4.3999 4.34587 4.57026 4.5 4.75 4.5C4.92974 4.5 5.1001 4.34587 5.1001 4.125ZM8.5 4.5625V2.375C8.5 2.27094 8.45989 2.17378 8.39258 2.10449C8.32575 2.0357 8.23797 2 8.1499 2H1.3501C1.26203 2 1.17425 2.0357 1.10742 2.10449C1.04011 2.17378 1 2.27094 1 2.375V5.875C1 5.97906 1.04011 6.07622 1.10742 6.14551C1.17425 6.2143 1.26203 6.25 1.3501 6.25H4.75C5.02614 6.25 5.25 6.47386 5.25 6.75C5.25 7.02614 5.02614 7.25 4.75 7.25H1.3501C0.987301 7.25 0.64212 7.10168 0.390137 6.84229C0.138633 6.58338 0 6.23507 0 5.875V2.375C0 2.01493 0.138633 1.66662 0.390137 1.40771C0.64212 1.14832 0.987302 1 1.3501 1H8.1499C8.5127 1 8.85788 1.14832 9.10986 1.40771C9.36137 1.66662 9.5 2.01493 9.5 2.375V4.5625C9.5 4.83864 9.27614 5.0625 9 5.0625C8.72386 5.0625 8.5 4.83864 8.5 4.5625ZM2.2041 3.625C2.48024 3.625 2.7041 3.84886 2.7041 4.125C2.7041 4.40114 2.48024 4.625 2.2041 4.625H2.2002C1.92405 4.625 1.7002 4.40114 1.7002 4.125C1.7002 3.84886 1.92405 3.625 2.2002 3.625H2.2041ZM7.3042 3.625C7.58034 3.625 7.8042 3.84886 7.8042 4.125C7.8042 4.40114 7.58034 4.625 7.3042 4.625H7.2998C7.02375 4.62489 6.7998 4.40108 6.7998 4.125C6.7998 3.84892 7.02375 3.62511 7.2998 3.625H7.3042ZM6.1001 4.125C6.1001 4.87063 5.50915 5.5 4.75 5.5C3.99085 5.5 3.3999 4.87063 3.3999 4.125C3.3999 3.37937 3.99085 2.75 4.75 2.75C5.50915 2.75 6.1001 3.37937 6.1001 4.125Z",
            fill: "#821938"
          }),
          height: "12",
          width: "12",
          transform: "translate(1, 1)",
          viewBox: "0 0 10 10"
        })
      };
    case "Billed" :
      return {
        bgColor: "#FBE8F8",
        textColor: "#7F1C5C",
        borderColor: "#F6ABE6",
        iconSvg: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("path", {
            d: "M9 7.22217H4.6001V7.61133C4.60008 7.74425 4.58026 7.8749 4.54346 8H8.6001C8.70814 7.99997 8.81073 7.9574 8.88525 7.88379C8.95944 7.81044 8.99994 7.7123 9 7.61133V7.22217ZM6.3501 4C6.62619 4.00005 6.8501 4.22389 6.8501 4.5C6.8501 4.77611 6.62619 4.99995 6.3501 5H4.1001C3.82396 5 3.6001 4.77614 3.6001 4.5C3.6001 4.22386 3.82396 4 4.1001 4H6.3501ZM6.3501 2.22217C6.62618 2.22222 6.85007 2.44608 6.8501 2.72217C6.8501 2.99828 6.62619 3.22212 6.3501 3.22217H4.1001C3.82396 3.22217 3.6001 2.99831 3.6001 2.72217C3.60013 2.44605 3.82397 2.22217 4.1001 2.22217H6.3501ZM1.7998 1.38867C1.79975 1.28766 1.7593 1.18957 1.68506 1.11621C1.61051 1.04258 1.50798 1 1.3999 1C1.29186 1.00003 1.18927 1.0426 1.11475 1.11621C1.04056 1.18956 1.00006 1.2877 1 1.38867V2.22217H1.7998V1.38867ZM2.7998 7.61133C2.79986 7.71237 2.84076 7.81042 2.91504 7.88379C2.98959 7.95742 3.09212 8 3.2002 8C3.30818 7.99995 3.41036 7.95736 3.48486 7.88379C3.55915 7.81042 3.60004 7.71237 3.6001 7.61133V7.1665C3.60014 6.91406 3.70158 6.67317 3.88037 6.49658C4.05895 6.32021 4.29991 6.22222 4.5498 6.22217H7.6499V1.38867C7.64984 1.28768 7.60937 1.18957 7.53516 1.11621C7.46988 1.05174 7.38313 1.01105 7.29004 1.00195L7.25 1H2.74316C2.77998 1.12512 2.79978 1.25572 2.7998 1.38867V7.61133ZM8.6499 6.22217H9.0498C9.26854 6.22217 9.48069 6.29712 9.6499 6.43408L9.71973 6.49658L9.78271 6.56592C9.92196 6.73377 9.99996 6.94561 10 7.1665V7.61133C9.99994 7.98155 9.85096 8.33531 9.58789 8.59521C9.3249 8.85496 8.96938 8.99997 8.6001 9H3.2002C2.83088 9 2.47542 8.85498 2.2124 8.59521C1.94924 8.33529 1.79986 7.98162 1.7998 7.61133V3.22217H0.950195C0.70023 3.22217 0.458897 3.12417 0.280273 2.94775C0.10152 2.77115 1.45484e-05 2.53026 0 2.27783V1.38867C5.81911e-05 1.01845 0.149036 0.664695 0.412109 0.404785C0.675101 0.14504 1.03062 2.55243e-05 1.3999 0H7.25L7.3877 0.00683594C7.70672 0.0381141 8.00766 0.177493 8.23779 0.404785C8.5009 0.664699 8.64984 1.01843 8.6499 1.38867V6.22217Z",
            fill: "#7F1C5C"
          }),
          height: "11",
          width: "11",
          viewBox: "0 0 10 9"
        })
      };
  }
}

let Badge$1 = {
  toStyleSet: toStyleSet$1
};

let BusinessSecondaryStatus = {
  toLabel: toLabel$2,
  Badge: Badge$1
};

function fromRaw$1(value) {
  if (value === "OTHER_REASON") {
    return "OtherReason";
  } else if (value === "PRODUCT_NOT_COMPLIANT_OR_DAMAGED") {
    return "ProductNotCompliantOrDamaged";
  } else if (value === "CANCELLATION_SALE") {
    return "CancellationSale";
  } else {
    return "CashingError";
  }
}

function toLabel$3(value) {
  switch (value) {
    case "CancellationSale" :
      return I18n.t("sale.refund_receipt_reason.cancellation_sale.label");
    case "CashingError" :
      return I18n.t("sale.refund_receipt_reason.cashing_error.label");
    case "ProductNotCompliantOrDamaged" :
      return I18n.t("sale.refund_receipt_reason.product_not_compliant_or_damaged.label");
    case "OtherReason" :
      return I18n.t("sale.refund_receipt_reason.other_reason.label");
  }
}

let RefundReceiptReason = {
  fromRaw: fromRaw$1,
  toLabel: toLabel$3
};

export {
  toString,
  UnknownStringValue,
  fromStringExn,
  toLabel,
  toRevenueImpactTotalAmounts,
  Status,
  BusinessSecondaryStatus,
  RefundReceiptReason,
}
/* I18n Not a pure module */
